export const POST_NEW_FLEET = 'POST_NEW_FLEET'
export const FETCH_VEHICLE_BY_PLATE = 'FETCH_VEHICLE_BY_PLATE'
export const FETCH_MODELS_BY_BRAND = 'FETCH_MODELS_BY_BRAND'
export const FETCH_SPECIFIC_VEHICLE_DATA = 'FETCH_SPECIFIC_VEHICLE_DATA'
